<template>
  <q-card style="min-width: 55vw">
    <q-card-section class="row items-center bg-primary">
      <q-icon name="fas fa-city" color="white" />
      <span class="text-subtitle1 q-ml-sm text-white">重新修改样本</span>
    </q-card-section>
    <q-card-section class="bg-yellow-3 q-ma-md rounded-borders">
      <li>如需要其他访员再次调查该样本，可在此处重置样本。<br /></li>
      <li>
        重新分配样本给新的指定样本组，样本原有的信息（关于样本的问卷信息、拒访信息、无法找到的信息）并<span
          class="text-bold text-red-10"
          >不会删除</span
        >，依然会存储在数据库中。<br />
      </li>
      <li>
        如需调整分组，选择下方小组，再点击<span class="text-bold text-red-10"
          >重置样本，并移入该分组
        </span>
      </li>
      <li>
        如无需调整分组，点击<span class="text-bold text-red-10">
          重置样本，不调整分组</span
        >即可。
      </li>
    </q-card-section>
    <q-card-section class="q-mx-lg" v-if="sampleGroupList">
      <q-list
        bordered
        :class="`q-mt-sm rounded-borders ${
          currentSampleGroupId === sampleGroup.id ? 'bg-orange-2' : 'bg-white'
        }`"
        v-for="sampleGroup in sampleGroupList"
        :key="sampleGroup.id"
      >
        <q-item
          class="rounded-borders"
          clickable
          v-ripple
          @click="selectedGroup(sampleGroup.id)"
        >
          <q-item-section avatar>
            <q-icon color="primary" name="fas fa-list-alt" />
          </q-item-section>
          <q-item-section class="text-bold">{{
            sampleGroup.name
          }}</q-item-section>
          <q-item-section v-if="sampleGroup.user_group"
            >关联小组：{{ sampleGroup.user_group.name }}</q-item-section
          >
        </q-item>
      </q-list>
    </q-card-section>

    <q-card-actions align="right" class="q-pa-lg">
      <q-btn flat label="取消" color="primary" v-close-popup />
      <q-btn
        outline
        label="重置样本，不调整分组"
        @click="resetSample"
        color="primary"
        v-close-popup
      />
      <q-btn
        flat
        :disable="!currentSampleGroupId"
        class="bg-primary text-white rounded-borders"
        @click="moveSampleGroup"
        v-close-popup
      >
        <span>重置样本，并移入该分组</span>
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { getSampleGroupList } from "@/api/endpoints/sample-group/getSampleGroupList";
import { resetRejectedSample } from "@/api/endpoints/rejected-sample/resetRejectedSample";
import { updateSampleGroupSamples } from "@/api/endpoints/sample-group/updateSampleGroupSamples";
import { EventBus } from "@/bus/index";
import { SAMPLE_RESET_LIST_CHANGED } from "@/bus/admin.events";
export default {
  data() {
    return {
      sampleGroupList: [],
      currentSampleGroupId: "",
    };
  },
  props: {
    sampleId: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    async getGroupList() {
      try {
        const res = await getSampleGroupList();
        this.sampleGroupList = res;
        console.log(this.sampleGroupList);
      } catch (error) {
        this.$q.notify({ type: "danger", message: "获取样本分组列表失败" });
      }
      // console.log(res , '<- res')
    },
    async selectedGroup(groupId) {
      // console.log(groupId)
      this.currentSampleGroupId = groupId;
    },
    async resetSample() {
      try {
        const res = await resetRejectedSample(this.sampleId);
        if (res.status) {
          this.$q.notify({
            type: "danger",
            message: "清除样本状态失败，请检查网络或刷新系统",
          });
        }
        console.log(res, "res");
        EventBus.$emit(SAMPLE_RESET_LIST_CHANGED);
      } catch (error) {
        this.$q.notify({
          type: "danger",
          message: "未知错误：" + error.toString(),
        });
      }
    },
    async moveSampleGroup() {
      await this.resetSample(this.sampleId);
      try {
        const updateRes = await updateSampleGroupSamples(
          this.currentSampleGroupId,
          {
            append: [this.sampleId],
          }
        );
        if (updateRes.status && updateRes.error) {
          console.log(updateRes, "res");
          this.$q.notify({
            type: "danger",
            message: "清除样本状态失败，请检查网络或刷新系统",
          });
        }
      } catch (error) {
        console.log("error 未知错误：", error);
        this.$q.notify({
          type: "danger",
          message: "清除样本状态失败，请检查网络或刷新系统",
        });
      }
    },
  },
};
</script>

<style>
</style>